export class StaysEditableAfterError extends Error {
  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'StaysEditableAfterError';
  }

  readonly staysEditableAfterError = true;
}

/** If the error has a `staysEditableAfterError` property, return its value. Otherwise, return false. */
export function staysEditableAfterError(error: unknown): boolean {
  if (error instanceof Error && 'staysEditableAfterError' in error) {
    return error.staysEditableAfterError as boolean;
  }
  return false;
}
